import React from 'react'
import { getTheme } from '../../utils/theme'
import LanguageSelector from '../LanguageSelector/LanguageSelector'
import defaultLogo from '../../assets/logo.svg'
import styles from './Header.module.css'

const Header = () => {
    const theme = getTheme()

    if (theme?.disableHeader) {
        return null
    }

    const logo = theme?.logo || defaultLogo
    const brandName = logo === defaultLogo ? 'PayFlow' : 'Logo'

    return (
        <header className={styles.header}>
            <div className={styles.headerLeft}></div>
            <div className={styles.headerCenter}>
                <img src={logo} alt={brandName} className={styles.logo} />
            </div>
            <div className={styles.headerRight}>
                {!theme?.disableSwitchLang && <LanguageSelector />}
            </div>
        </header>
    )
}

export default Header
